import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import s from './Contact.css';
import ContactForm from '../../components/ContactForm';
import messages from '../../locale/messages';

class Contact extends React.Component {
  render() {

    return (
      <div className={s.root}>
        <div className={s.container}>
          <h1 className={s.pageTitle}>
            <FormattedMessage {...messages.batch2ContactH1} />
          </h1>
          <ContactForm />
          {/* <h1>Contact Page</h1>
          <p>Coming soon</p> */}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Contact);
